export const TYPE_VALUES = {
  frequency: "frequency",
  period: "period",
  review: "review",
};
